import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      stevedoresList: 'defaultStevedore/getDefault',
      user: 'userProfile/userInfo',
    }),
  },
  methods: {
    findStevedore({ cargo_receiver_name }) {
      return cargo_receiver_name
    },
    loadLocationFilter(bid, field = 'load_point') {
      let res = ''

      if (bid && bid[field]) {
        res = bid[field].replace(/&nbps;/g, ' ')
        const city = res.split(',')[1].split(' ')

        city.shift()
        res = city.join(' ')
      }

      return res
    },
  },
}
